import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ResponderAuthState } from "types/authTypes";
import { Responder } from "types/assessmentTypes";

const initialState: ResponderAuthState = {
  responder: null,
  token: sessionStorage.getItem("responder-token"),
  initialized: false,
  loading: false,
};

const responderAuthSlice = createSlice({
  name: "responderAuth",
  initialState,
  reducers: {
    setResponder(state, action: PayloadAction<Responder | null>) {
      state.responder = action.payload;
    },

    setResponderToken(state, action: PayloadAction<string | null>) {
      state.token = action.payload;

      if (action.payload) {
        sessionStorage.setItem("responder-token", action.payload);
      } else {
        sessionStorage.removeItem("responder-token");
      }
    },

    setResponderInitialized(state, action: PayloadAction<boolean>) {
      state.initialized = action.payload;
    },

    setResponderLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    clearResponderAuth(state) {
      state.responder = null;
      state.token = null;
      state.initialized = true;
      state.loading = false;

      sessionStorage.removeItem("responder-token");
    },
  },
});

export const {
  setResponder,
  setResponderToken,
  setResponderInitialized,
  setResponderLoading,
  clearResponderAuth,
} = responderAuthSlice.actions;

export default responderAuthSlice.reducer;
